import PageTitle from '@/components/PageTitle';
import useProductsContext from '@hooks/useProductsContext';
import { useAuthContext } from '@hooks/useAuthContext';
import Skeleton from 'react-loading-skeleton';
import classes from './index.module.css';
import Content from './content';
import Banner from './Banner';

const TitlePart = () => (
  <div className={classes.header}>
    <PageTitle title="Dashboard" />
    <div className={classes.title_bar_wrapper}>
      <div className={classes.title_bar_range}>Data range: </div>
      <div className={classes.title_bar_tabs}>Last 6 months</div>
      <div className={classes.title_bar_desc}>
        Does not include data from the current UTC day
      </div>
    </div>
  </div>
);
export default function Dashboard() {
  const {
    productsGallery, galleryLoading, productsInvolved,
  } = useProductsContext();
  const { merchantName } = useAuthContext();

  if (galleryLoading) {
    return (
      <div className={classes.wrapper}>
        <div className={classes.title}>
          <Skeleton containerClassName={classes.title} style={{ height: '100%', width: '150PX' }} />
        </div>
        <div className={classes.title_bar_wrapper}>
          <div className={classes.title_bar_range}>
            <Skeleton containerClassName={classes.title} style={{ height: '100%', width: '80PX' }} />
          </div>
          <Skeleton containerClassName={classes.title} style={{ height: '100%', width: '150PX' }} />
          <div className={classes.title_bar_desc}>
            <Skeleton containerClassName={classes.title} style={{ height: '100%', width: '280PX' }} />
          </div>
        </div>
        <Content galleryLoading={galleryLoading} />
      </div>

    );
  }
  return (
    <div className={classes.wrapper}>
      {!productsInvolved?.length && <Banner name={merchantName} />}
      <TitlePart />
      <Content productsGallery={productsGallery} galleryLoading={galleryLoading} />
    </div>
  );
}
